import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

let kejianrouter = new Router({
  routes: [
    {
      path: '/Login',
      name: 'Login',
      component: () => import('./views/Login.vue')
    },{
      path: '/',
      name: 'home',
      component: () => import('./views/Home.vue'),
    },
    {
      path: '/AboutUs',
      name: 'AboutUs',
      component: () => import('./views/AboutUs.vue'),
      meta: { requireAuth: true }
    },
    {
      path: '/case',
      name: 'case',
      component: () => import('./views/Case.vue'),
      meta: { requireAuth: true }
    },
    {
      path: '/information',
      name: 'information',
      component: () => import('./views/information.vue'),
      meta: { requireAuth: true }
    },
    {
      path: '/contactUs',
      name: 'contactUs',
      component: () => import('./views/contactUs.vue'),
      meta: { requireAuth: true }
    },{
      path: '/allCity',
      name: 'allCity',
      component: () => import('./views/allCity.vue'),
      meta: { requireAuth: true }
    }
  ]
})

// 判断是否需要登录权限 以及是否登录
kejianrouter.beforeEach((to, from, next) => {
  window.scrollTo(0, 0);
  // 判断是否需要登录权限
  if (to.matched.some(res => res.meta.requireAuth)) {
    // 判断是否登录
    if (localStorage.getItem('token')) {
      next()
    } else {
      // 没登录则跳转到登录界面
      next({
        path: '/Login',
        query: {
          redirect: to.fullPath
        }
      })
    }
  } else {
    next()
  }
})

export default kejianrouter